module.exports = {
  "midea-overlay": {
    "position": "fixed",
    "left": 0,
    "top": 0,
    "bottom": 0,
    "right": 0,
    "zIndex": 1000
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-ce1075a6!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-overlay/index.vue
// module id = 540
// module chunks = 0 1